import { IUserInfo } from "../DataStorage/IUserInfo";
import { IFlowStepPlugin } from "./IFlowStepPlugin";

export class DefaultFlowStepPlugin implements IFlowStepPlugin {
    defaultList: string[] = [];
    myDefaultList: string[] = [];

    getInitialFlowSteps(_user: IUserInfo): Promise<string[]> {
        let output = [...this.defaultList];
        output.push(...this.myDefaultList);
        return Promise.resolve(output);
    }

    addToDefaultList(_user: IUserInfo, type: string): Promise<void> {
        if (this.defaultList.indexOf(type) === -1) this.defaultList.push(type);
        return Promise.resolve(undefined);
    }

    addToMyDefaultList(_user: IUserInfo, type: string): Promise<void> {
        if (this.myDefaultList.indexOf(type) === -1) this.myDefaultList.push(type);
        return Promise.resolve(undefined);
    }

    removeFromDefaultList(_user: IUserInfo, type: string): Promise<void> {
        const index = this.defaultList.indexOf(type, 0);
        if (index > -1) {
            this.defaultList = this.defaultList.splice(index, 1);
        }
        return Promise.resolve(undefined);
    }

    removeFromMyDefaultList(_user: IUserInfo, type: string): Promise<void> {
        const index = this.myDefaultList.indexOf(type, 0);
        if (index > -1) {
            this.myDefaultList = this.defaultList.splice(index, 1);
        }
        return Promise.resolve(undefined);
    }
}
